module.exports = "/images/marker-shadow.png?a0c6cc1401c107b501efee6477816891";